import Fuse from 'fuse.js';
import { useMemo } from 'react';

import FuseOptionKey = Fuse.FuseOptionKey;
import FuseResult = Fuse.FuseResult;
import IFuseOptions = Fuse.IFuseOptions;
import type { SetRequired } from 'type-fest';

type Props<Value> = {
  query: string;
  list: readonly Value[];
  getKeys: (query: string) => Array<FuseOptionKey<Value>>;
  optionsLimit: number;
};

export const useFuseSearch = <Value>(props: Props<Value>): SetRequired<FuseResult<Value>, 'matches'>[] => {
  return useMemo(() => {
    return fuseSearch(props);
  }, [props.query, props.list, props.getKeys, props.optionsLimit]);
};

export const fuseSearch = <Value>(
  { query, list, getKeys, optionsLimit }: Props<Value>,
  fuseOptions: IFuseOptions<Value> = {},
): SetRequired<FuseResult<Value>, 'matches'>[] => {
  const queryTrimmed = query.trim();

  if (!queryTrimmed) {
    return [];
  }

  return new Fuse(list, {
    keys: getKeys(queryTrimmed),
    threshold: 0.4,
    includeMatches: true,
    ...fuseOptions,
  }).search(queryTrimmed, { limit: optionsLimit }) as SetRequired<FuseResult<Value>, 'matches'>[];
};
